import { Image, Link, StyleSheet, Text, View } from "@react-pdf/renderer";
import { extractUploadFileName, GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2 } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingCount, getGoalTrackingPercentage } from "helpers/assessment";
import attachments_img from "Assets/images/AttachmentIcon.png"
import Html from "react-pdf-html";
import graphSliderImg from "../../../../../Assets/images/graphSliderImg.png"
import moment from "moment";
import PDFHtmlRenderer from "./PDFHtmlRenderer";

const ObservationsGoalsSection = ({ data, therapistDetails, showChart = false, chartImages = [], styles, type = "Observation" }) => {
  console.log("data >>>", data);
  return (
    <>
      {data?.length > 0 && data?.map((item, index) => {
        // const attachments = goal?.goal_attachementData ? JSON.parse(goal?.goal_attachementData) : [];
        console.log('chartImages[index]', data)
        return (
          <View>
            <View >
              <View style={{ width: "100%" }}>
                <View style={{ width: "40% " }}>
                  <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>Area: <Text style={{ fontWeight: "normal" }}>{item?.area_title}</Text> </Text>
                  <View style={{ marginTop: 7 }} >
                    <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>GOAL</Text>
                    <Text style={{ ...styles.para, marginTop: 4 }}>
                      {item?.goal_title}
                    </Text>
                  </View>
                  <View style={{ marginTop: 7 }} >
                    <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>DETAILS</Text>
                    <Text style={{ ...styles.para, marginTop: 4 }}>
                      {item?.goal_details}
                    </Text>
                  </View>
                  <View style={{ marginTop: data?.[index]?.show_tracker != "hidden" && "10px" }}>
                    {chartImages?.length && data?.[index]?.show_tracker != "hidden" && (
                      <Image src={chartImages[index]} />
                    )}
                  </View>
                </View>
                <Text style={{ ...styles?.para, marginTop: "5px", marginBottom: "10px", fontSize: 9, lineHeight: "13px" }}>
                  {item?.notes}
                </Text>
              </View>
              <View style={{ width: "100%", }}>
                {
                  item?.strategy?.map((strategy, strategyIndex) => <>
                    <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>STRATEGY {strategyIndex + 1}</Text>
                    <View style={{ marginTop: 5 }}>
                      <PDFHtmlRenderer
                        style={{ ...styles?.para, fontSize: 9 }}
                        data={strategy?.answers}
                      />
                      {strategy?.attachmentData?.length && (
                        <View style={{ marginBottom: "10px" }}>
                          {strategy?.attachmentData?.map((item, index) => (
                            <View style={{ ...styles.flex, marginTop: '7px' }}>
                              <Link
                                key={index}
                                src={item?.attachment_name}
                                style={{ ...styles.fontSemibold, ...styles.subHeading, color: "#000" }}
                              >
                                {extractUploadFileName(item?.attachment_name)}
                              </Link>
                            </View>
                          ))}
                        </View>
                      )}
                    </View>
                  </>
                  )
                }
              </View>
            </View>
          </View>
        )
      })}
    </>
  )
}


export default ObservationsGoalsSection;